import { render, staticRenderFns } from "./VehicleProvisionSummary.vue?vue&type=template&id=2dddb746&"
import script from "./VehicleProvisionSummary.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionSummary.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProvisionSummary.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSpace,QBtnDropdown,QCard,QCardSection,QSeparator,QTable,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QSpace,QBtnDropdown,QCard,QCardSection,QSeparator,QTable,QTr,QTd}, component.options.components || {})
